import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { editStorageArea } from "../../../../services/storage-area/edit";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import * as yup from "yup";
import { useFormik } from "formik";
import { Input } from "../../../../components/Input/input";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  FiscalBreakdownArray,
  StoragePlaceArray,
  StorageTypeArray,
  TemperatureConditionArray,
} from "./helpers";
import { StyledButton } from "../../../../components/Button/button";
import { GetStorageAreas } from "../../../../services/storage-area/get/types";
import { useEffect } from "react";

interface StorageAreaEditFormProps {
  id_obszar_skladowania: string | undefined;
  areaToEdit: GetStorageAreas;
}
const StorageAreaEditForm = ({
  id_obszar_skladowania,
  areaToEdit,
}: StorageAreaEditFormProps) => {
  const EditStorageAreaMutation = useMutation(editStorageArea, {
    onSuccess: (res) => {
      toast.success("Edytowano pomyślnie!", {
        toastId: "StorageAreaEditSuccessfully",
        ...settings,
      });
    },
  });

  const validationSchema = yup.object({
    kod: yup
      .string()
      .required("Kod jest wymagany")
      .max(100, "Maksymalnie 100 znaków"),
  });
  const formik = useFormik({
    initialValues: {
      kod: areaToEdit.kod,
      typ_skladowania: areaToEdit.typ_skladowania,
      miejsce: areaToEdit.miejsce,
      podzial_fiskalny: areaToEdit.podzial_fiskalny,
      warunek_temperaturowy: areaToEdit.warunek_temperaturowy,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_obszar_skladowania: id_obszar_skladowania,
        kod: formik.values.kod,
        typ_skladowania: formik.values.typ_skladowania,
        miejsce: formik.values.miejsce,
        podzial_fiskalny: formik.values.podzial_fiskalny,
        warunek_temperaturowy: formik.values.warunek_temperaturowy,
      };

      EditStorageAreaMutation.mutate(body);
    },
  });
  return (
    <FormWrapper onSubmit={formik.handleSubmit}>
      <Input
        label="Kod"
        placeholder="Wpisz kod..."
        id="kod"
        name="kod"
        value={formik.values.kod}
        onChange={formik.handleChange}
        error={formik.touched.kod && Boolean(formik.errors.kod)}
        helperText={formik.touched.kod && formik.errors.kod}
        onBlur={formik.handleBlur}
        variant="filled"
      />
      <FormControl fullWidth>
        <InputLabel id="typ_skladowania-label">Typ składowania</InputLabel>
        <Select
          placeholder="typ_skladowania"
          labelId="typ_skladowania-label"
          label="typ_skladowania"
          id="typ_skladowania"
          name="typ_skladowania"
          value={formik.values.typ_skladowania}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {StorageTypeArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <InputLabel id="miejsce-label">Miejsce </InputLabel>
        <Select
          placeholder="miejsce"
          labelId="miejsce-label"
          label="miejsce"
          id="miejsce"
          name="miejsce"
          value={formik.values.miejsce}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {StoragePlaceArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="podzial_fiskalny-label">Podział fiskalny</InputLabel>
        <Select
          placeholder="podzial_fiskalny"
          labelId="podzial_fiskalny-label"
          label="podzial_fiskalny"
          id="podzial_fiskalny"
          name="podzial_fiskalny"
          value={formik.values.podzial_fiskalny}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {FiscalBreakdownArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl fullWidth>
        <InputLabel id="warunek_temperaturowy-label">
          Warunek temperaturowy
        </InputLabel>
        <Select
          placeholder="warunek_temperaturowy"
          labelId="warunek_temperaturowy-label"
          label="warunek_temperaturowy"
          id="warunek_temperaturowy"
          name="warunek_temperaturowy"
          value={formik.values.warunek_temperaturowy}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          style={{ backgroundColor: "white" }}
        >
          {TemperatureConditionArray.map((item, index) => (
            <MenuItem value={index}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <StyledButton
        disabled={EditStorageAreaMutation.isLoading || !formik.isValid}
        type="submit"
        variant="contained"
      >
        Zapisz
      </StyledButton>
    </FormWrapper>
  );
};

export default StorageAreaEditForm;

const FormWrapper = styled.form`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
